import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { take, distinctUntilChanged, mergeMap, share } from 'rxjs/operators';

import { Token } from './token.model';
import { TokenProvider } from './token-provider';
import { authHttpKey, authHttpPrefix } from './authorization.const';
import { TokenRepository } from './token.repository';
import { ConfigService } from './config.service';

@Injectable()
export class TokenService {

  private refreshPromise: Promise<Token> = null;
  private tokenSubject: ReplaySubject<string> = new ReplaySubject<string>(1);
  private request: Observable<Token> = null;

  constructor(
    private tokenProvider: TokenProvider,
    private refreshTokenProvider: TokenProvider,
    private tokenRepository: TokenRepository,
    private config: ConfigService
  ) {
    this.request = this.getReqestStream();
  }

  public setToken(token: Token): void {
    if (null === token) {
      return;
    }

    this.tokenProvider.setToken(token.value);
    this.refreshTokenProvider.setToken(token.refreshToken);
  }

  public getTokenString(): string {
    return this.tokenProvider.getToken();
  }

  public canRefreshToken(): boolean {
    const refreshToken: string = this.refreshTokenProvider.getToken();

    return (
        this.tokenRepository.canRefresh() &&
        'string' === typeof refreshToken &&
        '' !== refreshToken
      );
  }

  public clearToken(): void {
    this.tokenProvider.removeToken();
    this.refreshTokenProvider.removeToken();
  }

  public getPrefixedToken(): string {
    return authHttpPrefix + this.getTokenString();
  }

  public getTokenHeaderName(): string {
    return authHttpKey;
  }

  public setRefreshTokenApiUrl(url: string): void {
    this.config.setRefreshTokenApiUrl(url);
  }

  public refresh(): Observable<Token> {
    this.tokenSubject.next(this.refreshTokenProvider.getToken());

    return this.request.pipe(take(1));
  }

  private getReqestStream(): Observable<Token> {
    return this.tokenSubject
      .pipe(
        distinctUntilChanged(),
        mergeMap(
          (token: string): Observable<Token> =>
            this.tokenRepository.refresh(token)
        ),
        share()
      );
  }

}
